import { logEvent, Analytics } from 'firebase/analytics';
import { analytics } from './firebase';

// Helper to safely log events
function safeLogEvent(eventName: string, params?: Record<string, any>) {
  if (!analytics) return;
  logEvent(analytics as Analytics, eventName as any, params);
}

// Course events
export function trackCourseView(courseId: string, courseTitle: string) {
  safeLogEvent('view_course', {
    course_id: courseId,
    course_title: courseTitle,
  });
}

export function trackCoursePurchaseStart(courseId: string, courseTitle: string, price: number) {
  safeLogEvent('begin_checkout', {
    currency: 'EUR',
    value: price,
    items: [{
      item_id: courseId,
      item_name: courseTitle,
    }],
  });
}

export function trackCoursePurchaseComplete(courseId: string, courseTitle: string, price: number) {
  safeLogEvent('purchase', {
    currency: 'EUR',
    value: price,
    items: [{
      item_id: courseId,
      item_name: courseTitle,
    }],
  });
}

// Session events
export function trackSessionStart(sessionId: string, sessionTitle: string, courseId: string) {
  safeLogEvent('session_start', {
    session_id: sessionId,
    session_title: sessionTitle,
    course_id: courseId,
  });
}

export function trackSessionComplete(sessionId: string, sessionTitle: string, courseId: string) {
  safeLogEvent('session_complete', {
    session_id: sessionId,
    session_title: sessionTitle,
    course_id: courseId,
  });
}

// Video events
export function trackVideoStart(materialId: string, materialTitle: string, sessionId: string) {
  safeLogEvent('video_start', {
    material_id: materialId,
    material_title: materialTitle,
    session_id: sessionId,
  });
}

export function trackVideoProgress(materialId: string, progress: number, sessionId: string) {
  // Only track at 25%, 50%, 75%, 100%
  const milestones = [25, 50, 75, 100];
  if (milestones.includes(Math.floor(progress))) {
    safeLogEvent('video_progress', {
      material_id: materialId,
      progress: Math.floor(progress),
      session_id: sessionId,
    });
  }
}

export function trackVideoComplete(materialId: string, materialTitle: string, sessionId: string) {
  safeLogEvent('video_complete', {
    material_id: materialId,
    material_title: materialTitle,
    session_id: sessionId,
  });
}

// Navigation events
export function trackPageView(pageName: string, pageParams?: Record<string, string>) {
  safeLogEvent('page_view', {
    page_title: pageName,
    ...pageParams,
  });
}

// User events
export function trackSignIn(method: string) {
  safeLogEvent('login', { method });
}

export function trackSignOut() {
  safeLogEvent('logout');
}

// Error tracking
export function trackError(errorType: string, errorMessage: string) {
  safeLogEvent('exception', {
    description: `${errorType}: ${errorMessage}`,
    fatal: false,
  });
}

